import { DateTransform } from '@/shared/utilities/class-validator-extends';
import { Transform, Type } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID, MinLength } from 'class-validator';
import type { Dayjs } from 'dayjs';

export type ConversationType = 'DIRECT' | 'GROUP' | 'CHANNEL' | 'SUBCHANNEL';
export class Conversation {
  userId?: string;

  @IsNumber()
  pinGroup?: number = 0;

  @Transform(DateTransform.toClass, { toClassOnly: true })
  @Transform(DateTransform.toPlain, { toPlainOnly: true })
  @Type(() => String)
  sortTimestamp?: Dayjs;

  conversationId?: string;

  @IsOptional()
  @IsString()
  conversationAvatarRef?: string;

  @IsString()
  @IsNotEmpty({ message: 'Tên nhóm không được để trống' })
  @MinLength(2, { message: 'Tên nhóm phải có ít nhất 2 ký tự' })
  conversationName?: string;

  conversationType?: ConversationType;

  createdAt?: string;

  partnerId?: string;

  @IsOptional()
  @IsString()
  lastMessageContent?: string | null;

  @IsOptional()
  @IsUUID()
  lastMessageId?: string | null;

  @IsOptional()
  lastMessageTimestamp?: string | null;

  @IsOptional()
  @IsUUID()
  lastMessageSenderId?: string | null;

  @IsOptional()
  @IsUUID()
  lastSeenMessageId?: string | null;

  @IsOptional()
  lastSeenTimestamp?: string | null;

  @IsBoolean()
  muted = false;

  @IsNumber()
  unreadCount = 0;

  @IsOptional()
  metadata: any | null;

  @Transform(DateTransform.toClass, { toClassOnly: true })
  @Transform(DateTransform.toPlain, { toPlainOnly: true })
  @Type(() => String)
  updatedAt?: Dayjs;

  constructor(data: Partial<Conversation> = {}) {
    Object.assign(this, data);
  }

  toUpdateModel() {
    return {
      conversationName: this.conversationName,
      avatarRef: this.conversationAvatarRef
    };
  }
}
